// Single source of truth for the locales the builder can serve.
// Used by next.config.js (i18n) and helpers/class/RequestLocale.ts.
// The backend resolves content by a 2-letter `locale` param (see SystemHelper::locale),
// so every entry here must match a system_languages.lang_code (lowercase), or be mapped in backendCodes.
module.exports = {
  locales: [ 'en', 'el', 'de', 'fr', 'ru', 'it', 'cs' ],
  defaultLocale: 'en',
  // Locales whose system_languages.lang_code in the backend is not the standard code used here (URLs, <html
  // lang>, Intl): frontend locale -> backend code. Czech is stored as 'CH' in the backend.
  backendCodes: { cs: 'ch' }
}
